import { render, staticRenderFns } from "./servicosEditar.vue?vue&type=template&id=9010992a&scoped=true&"
import script from "./servicosEditar.vue?vue&type=script&lang=js&"
export * from "./servicosEditar.vue?vue&type=script&lang=js&"
import style0 from "./servicosEditar.vue?vue&type=style&index=0&id=9010992a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9010992a",
  null
  
)

export default component.exports